import PolicyManagement from 'modules/policies/policy-management/Main';
import AuditReadiness from 'modules/policies/audit-readiness/Main';
import PoliciesWrapper from 'modules/policies/components/PoliciesWrapper';
import AddPolicyManagement from 'modules/policies/policy-management/add-policy-management/Main';
import PolicyDetail from 'modules/policies/policy-management/policy-detail/Main';
import Guardrails from 'modules/policies/guardrails/Main';
// import UserSecurityPage from 'modules/home/manage-clients/dashboard/usersettings/UserSecurityPage';

const PoliciesRoutes = (): any => ({
  path: '',
  element: <PoliciesWrapper />,
  children: [
    {
      path: 'policy-management',
      element: <PolicyManagement />,
    },
    {
      path: 'policy-management/add',
      element: <AddPolicyManagement />,
    },
    {
      path: 'policy-management/edit/:policyId',
      element: <AddPolicyManagement />,
    },
    {
      path: 'policy-management/detail/:policyId',
      element: <PolicyDetail />,
    },
    {
      path: 'audit-readiness',
      element: <AuditReadiness />,
    },
    {
      path: 'guardrails',
      element: <Guardrails />,
    },
    // {
    //     path: 'security',
    //     element: <UserSecurityPage />,
    // },
  ],
});

export default PoliciesRoutes;
